import { render, staticRenderFns } from "./PageInputMoney.vue?vue&type=template&id=810a4844"
import script from "./PageInputMoney.vue?vue&type=script&lang=js"
export * from "./PageInputMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports